import moment from 'moment';
import _ from 'lodash';
import I18n from '../../config/i18n';
import Week, { CalendarBooking } from '../../utils/calendar/components/Week';
import CalendarComponent, {
  CalendarComponentProps,
  RenderWeeksProps,
} from '../../utils/calendar/CalendarComponent';
import { CalendarEntryWithDate } from '../availabilityWidget/api/bookingsApi';

import './BookingCalendar.css';

function getWeekBooking(date: moment.Moment, bookings: CalendarEntryWithDate): CalendarBooking[] {
  const weekDate = date.clone();
  const initialValue: CalendarBooking[] = [];
  return _.range(1, 8).reduce((weekBookings) => {
    const dateKey = weekDate.format('YYYY-MM-DD');
    if (dateKey in bookings) {
      const dayBooking: CalendarBooking = { ...bookings[dateKey], date: dateKey };
      weekBookings.push(dayBooking);
    }
    weekDate.add(1, 'd');
    return weekBookings;
  }, initialValue);
}

interface RenderBookingWeeksProps extends RenderWeeksProps {
  bookings: CalendarEntryWithDate;
}

function RenderBookingWeeks({
  bookings,
  month,
  clickable,
  selected,
  handleSelect,
}: RenderBookingWeeksProps): JSX.Element {
  const weeks = [];
  let done = false;
  const date = month.clone().startOf('month').startOf('isoWeek');
  let monthIndex = date.month();
  let count = 0;

  while (!done) {
    weeks.push(
      <Week
        bookings={getWeekBooking(date, bookings)}
        allBookings={bookings}
        clickable={!!clickable}
        date={date.clone()}
        key={date.toString()}
        month={month}
        selected={selected}
        onDaySelect={handleSelect}
      />,
    );
    date.add(1, 'w');
    done = (count += 1) > 2 && monthIndex !== date.month();
    monthIndex = date.month();
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{weeks}</>;
}

interface BookingCalendarProps extends CalendarComponentProps {
  bookings: CalendarEntryWithDate;
  onDateChange: (date: moment.Moment) => void;
  minCurrentDay?: boolean;
  clickable?: boolean;
}

export default function BookingCalendar({
  minCurrentDay,
  minDate,
  clickable,
  selected,
  bookings,
  onDateChange,
}: BookingCalendarProps): JSX.Element {
  return (
    <div className="booking-calendar">
      <CalendarComponent
        minCurrentDay={minCurrentDay}
        minDate={minDate}
        clickable={clickable}
        selected={selected}
        onDateChange={onDateChange}
        renderWeeks={(props: RenderWeeksProps): JSX.Element => (
          <RenderBookingWeeks {...props} bookings={bookings} />
        )}
      />

      <div className="booking-calendar-legend">
        <ul>
          <li className="booking-calendar-legend-item booking-calendar-legend-day-of-arrival">
            {I18n.t('search.availability.day_of_arrival')}
          </li>
          <li className="booking-calendar-legend-item booking-calendar-legend-free">
            {I18n.t('search.availability.free')}
          </li>
          <li className="booking-calendar-legend-item booking-calendar-legend-not-available">
            {I18n.t('search.availability.not_available')}
          </li>
        </ul>
      </div>
    </div>
  );
}

const defaultProps: Pick<BookingCalendarProps, 'clickable' | 'minCurrentDay'> = {
  clickable: true,
  minCurrentDay: true,
};

BookingCalendar.defaultProps = defaultProps;
